<template>
  <pt-previous-video-detail class="pt-previous-video-detail__page"></pt-previous-video-detail>
</template>

<script>
import PtPreviousVideoDetail from 'cps/famous-doctor-hall/pt-previous-video/pt-previous-video-detail/withData'
export default {
  name: 'pt-previous-video-detail__view',
  components: {
    'pt-previous-video-detail': PtPreviousVideoDetail
  }
}
</script>
